var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.2045 8.2045C8.64384 7.76517 9.35616 7.76517 9.7955 8.2045L18 16.409L26.2045 8.20451C26.6438 7.76517 27.3562 7.76517 27.7955 8.20451C28.2348 8.64385 28.2348 9.35616 27.7955 9.7955L19.591 18L27.7955 26.2045C28.2348 26.6438 28.2348 27.3562 27.7955 27.7955C27.3562 28.2348 26.6438 28.2348 26.2045 27.7955L18 19.591L9.7955 27.7955C9.35616 28.2348 8.64384 28.2348 8.20451 27.7955C7.76517 27.3562 7.76517 26.6438 8.20451 26.2045L16.409 18L8.2045 9.7955C7.76517 9.35616 7.76517 8.64384 8.2045 8.2045Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.3e172b1e9d4466f29a8d603d1dfd23d2.svg";
export { ForwardRef as ReactComponent };